import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
  requestOptions: Object = {
    headers: this.headers,
    responseType: 'text',
    withCredentials: true,
  };

  public statusbws(serial: string[]): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/statusbws`,
      { serial },
      this.requestOptions
    );
  }

  public statussuntech(serial: string[]): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/statussuntech`,
      { serial },
      this.requestOptions
    );
  }
}
